export default "__VITE_ASSET__CvRwHxPl__"